export default __webpack_public_path__ + "static/eric-9bae5f1b8e41c747f527f3438da52942.jpg";